import { ADD_NEW_CLIENT_SUCCESS, UPDATE_NEW_CLIENT_SUCCESS, CLIENT_DATA_ERROR, CLIENT_DATA_SUCCESS, CLIENT_DROPDOWN_FETCH,ALL_CLIENT_DATA_SUCCESS } from "./actiontype"

const initialState = {
  clientlist: [],
  newClient: null,
  updateClient: null,
  totalCount:0
}

const getclientData = (state = initialState, action) => {
  switch (action.type) {
    case CLIENT_DATA_SUCCESS:
      return {
        ...state,
        clientlist: action.payload.getClientRequest,   
        totalCount:action.payload.totalCount,
        clientlistError: null,
      };
    
      case CLIENT_DROPDOWN_FETCH:
        return {
          ...state,
          clientdropdown: action.payload.getClientRequest,
          clientlistError: null,
        };
      
    case ALL_CLIENT_DATA_SUCCESS:
      return {
        ...state,
        allclientslist: action.payload,
        clientlistError: null,
      };

    case CLIENT_DATA_ERROR:
      return { 
        ...state, 
        clientlistError: action.payload 
      };

    case ADD_NEW_CLIENT_SUCCESS:
      return { 
        ...state, 
        newClient: action.payload 
      };

    case UPDATE_NEW_CLIENT_SUCCESS:
      return { 
        ...state, 
        updateClient: action.payload 
      };

    default:
      return state;
  }
};

export default getclientData;
